module.exports = __webpack_public_path__ + "static/hcanteen-2009d1a92b4310821ac31cede9f6729e.jpg";